import React from "react";

interface GearHeadingsProps {
  variant: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  children: React.ReactNode;
  className?: string;
}

const GearHeadings: React.FC<GearHeadingsProps> = ({
  variant,
  children,
  className,
}) => {
  const baseStyles = "";
  const variantStyles = {
    h1: "text-[48px] leading-[56px]",
    h2: "text-[24px] leading-[28px] md:text-[30px] md:leading-[36px]",
    h3: "text-[20px] leading-[28px] md:text-[24px] md:leading-[32px]",
    h4: "text-[18px] leading-[26px] md:text-[20px] md:leading-[28px]",
    h5: "text-[16px] leading-[24px] md:text-[18px] md:leading-[26px]",
    h6: "text-[14px] leading-[20px] md:text-[16px] md:leading-[24px]",
  };

  const Tag = variant as keyof JSX.IntrinsicElements;

  return (
    <Tag
      className={`${baseStyles} ${variantStyles[variant]} ${className || ""}`}
    >
      {children}
    </Tag>
  );
};

export default GearHeadings;
